import styled from "styled-components";

export const SidebarContainer = styled.div`
  width: ${(props) => (props.isExpanded ? "240px" : "80px")};
  height: 100vh;
  background-color: ${props => props.theme.colors.sidebar};
  color: ${props => props.theme.colors.onColor};
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1100; /* Maior que a Navbar */
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
`;

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #444; /* Adiciona separação, se necessário */
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
`;

export const SidebarMenu = styled.ul`
  list-style: none;
  padding: 10px;
  flex-grow: 1;
`;

export const SidebarMenuItem = styled.li`
  padding: 10px;
  display: flex;
  align-items: center;
  gap: ${(props) => (props.isExpanded ? "10px" : "0")};

  a {
    color: white;
    text-decoration: none;
    display: flex;
    align-items: center;
  }

  .icon {
    font-size: 20px;
  }

  .label {
    display: ${(props) => (props.isExpanded ? "inline" : "none")};
  }
`;

export const SubmenuList = styled.ul`
  list-style: none;
  margin: 6px 0 0 0;
  display: ${(props) => (props.visible ? 'block' : 'none')};
  
  ${(props) => {
    if (props.isExpanded) {
      return `
        padding-left: 28px;
      `;
    } else {
      return `
        position: absolute;
        left: 85px;
        top: 25%;
        background-color: #222;
        border: 1px solid #444;
        border-radius: 4px;
        padding: 8px 0;
        min-width: 150px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
        z-index: 1200;
      `;
    }
  }}
`;

export const SubmenuItem = styled.li`
  padding: 8px 16px;
  a {
    color: #ddd;
    text-decoration: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: ${(props) => (props.isExpanded ? '8px' : '0')};
  }
  a:hover {
    color: #fff;
  }
  
  .icon {
    font-size: 16px;
    display: ${(props) => (props.isExpanded ? 'inline' : 'none')};
  }
  
  .label {
    display: inline;
  }
`;
